import { EuiSpacer } from '@elastic/eui';
import CardsAvm from 'components/Software/Other_Platforms/Domovea/domoveaCards';
import NavButtons from 'components/Software/Other_Platforms/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  CardsAvm,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};